

export function removeWhitespaces(str?: string | null) {
    if (str === undefined || str === null) {
      return '';
    }
    return String(str).replace(/\s+/g, '');
  }